import {
    Component,
    Input,
    Output,
    ElementRef,
    Renderer2,
    ViewChild,
    ChangeDetectorRef,
    EventEmitter,
    AfterViewInit
} from '@angular/core';
import { BaseComponent } from 'sharedFeatures/base';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';

declare var jQuery: any;

@Component({
    selector: 'expand-menu-item',
    templateUrl: './expand-menu-item.component.html',
    styleUrls: ['./expand-menu-item.component.less']
})

export class ExpandMenuItemComponent implements AfterViewInit {

    expanded: boolean = false;

    expandPicWidth: number = 0;
    collapsePicWidth: number = 0;

    @Input()
    itemWidth: number = 0;

    @Input()
    itemHeight: number = 0;

    space: number = 0;

    @Input()
    public initSpace: number = 20;

    @Input()
    itemText: string = $localize`Item Text`;

    @ViewChild('itemrow')
    itemrow!: ElementRef;

    @ViewChild('img')
    img!: ElementRef;

    @ViewChild('space')
    spaceEl!: ElementRef;

    @ViewChild('bottomspace')
    bottomSpaceEl!: ElementRef;

    @ViewChild('itmtext')
    itemTxt: ElementRef | undefined;

    picClass: string = 'collapsepic';

    @Input()
    titleTxtCls: string = 'item-title';

    @Input()
    titleRowCls: string = '';

    @Input()
    private isPicIncludedInBottomSpace: boolean = true;

    @Input()
    testId!: string;

    @Output()
    private itemClick: EventEmitter<any> = new EventEmitter<any>();

    constructor(private element: ElementRef, private renderer: Renderer2, private chDet: ChangeDetectorRef) {

    }


    onItemClick(): void {

        let expandedToSet = !this.expanded;

        if (expandedToSet) {
            this.expanded = expandedToSet;
            this.chDet.detectChanges();
            this.applyExpanded();
            if (this.itemTxt) {

                let begHeight = DomSmallUtils.height(this.itemTxt.nativeElement);
                this.renderer.setStyle(this.itemTxt.nativeElement, 'height', '0px');
                let tmp = this.itemTxt;
                jQuery(this.itemTxt.nativeElement).animate({ 'height': begHeight }, 500, () => {

                    this.renderer.setStyle(tmp.nativeElement, 'height', '');

                });
            }
        }

        else {
            if (this.itemTxt)
                jQuery(this.itemTxt.nativeElement).animate({ 'height': 0 }, 500, () => {

                    this.expanded = expandedToSet;
                    this.applyExpanded();

                });
        }


        this.itemClick.emit(expandedToSet);


    }

    public refresh() {

        if (this.itemTxt) {

            jQuery(this.itemTxt.nativeElement).stop(true, true);
            this.renderer.setStyle(this.itemTxt.nativeElement, 'height', '');


        }

    }

    applyExpanded(): void {

        if (this.expanded)
            this.picClass = 'expandpic';

        else
            this.picClass = 'collapsepic';

        this.applyPicClass();

        if (this.expanded) this.expandPicWidth = DomSmallUtils.width(this.img.nativeElement);
        else this.collapsePicWidth = DomSmallUtils.width(this.img.nativeElement);

        let picWidth = this.img.nativeElement.offsetWidth;
        if (this.expanded)
            this.space = this.initSpace - (this.expandPicWidth - this.collapsePicWidth);

        else this.space = this.initSpace;

        this.renderer.setStyle(this.spaceEl.nativeElement, "width", this.space + 'px');
        this.renderer.setStyle(this.bottomSpaceEl.nativeElement, 'width', (this.isPicIncludedInBottomSpace ? picWidth + this.space : 0) + 'px');

    }

    applyPicClass(): void {

        this.renderer.setAttribute(this.img.nativeElement, 'class', this.picClass);

    }


    ngOnInit(): void {}
    
    init(): void{
        let me = this;

        if (me.itemWidth) {
            me.renderer.setStyle(me.itemrow.nativeElement, "width", me.itemWidth + 'px');
            me.renderer.setStyle(me.element.nativeElement, "width", me.itemWidth + 'px');
        }
        if (me.itemHeight) me.renderer.setStyle(me.itemrow.nativeElement, "height", me.itemHeight + 'px');

        if (me.initSpace) me.renderer.setStyle(me.spaceEl.nativeElement, "width", me.initSpace + 'px');

        this.applyExpanded();
    }
    
    ngAfterViewInit() {
        this.init();
    }

    public setExpanded(expanded: boolean) {

        this.expanded = expanded;
        this.applyExpanded();

    }

    public isExpanded(): boolean {

        return this.expanded;

    }



}
